import React from "react";
import PageLayout from "../../shared/PageLayout";
import NotificationsLayout from "./notificationsLayout";

const Notifications: React.FC = () => {
    return (
        <PageLayout>
            <NotificationsLayout />
        </PageLayout>
    );
};

export default Notifications;
